import { AnyAction } from 'redux';
import { IListPageBar, Order } from '@app/models';
import {
    CHANGE_VIEW_TYPE,
    RESET_SORT_MENU,
    SHOW_SORT_MENU,
    SHOW_ORG_SELECT,
    SHOW_JIT_ORG_SELECT,
    HIDE_SORT_MENU,
    SET_ORDERBY_TYPES,
    CHANGE_ORDERBY_TYPE,
    SORTING_FILTERS_ENABLED,
    SORTING_SELECT_ENABLED,
    SORTING_ENABLED_OPTIONS,
    ADD_ACTIVE_FILTER,
    SET_ACTIVE_FILTERS,
    REMOVE_ACTIVE_FILTER,
    CLEAR_ACTIVE_FILTERS,
    SET_ORDER_BY_PROPERTY,
    SET_ORDER_BY_DIRECTION,
    SET_ACTION_MENU,
    SHOW_BULL_PHISH_ORG_SELECT
} from '@app/store/constants';
import { CHANGE_BULL_PHISH_ORGANIZATION_SELECT } from '@app/store/constants/bullPhishOrganizationSelect.constants';

const initialUserState: IListPageBar = {
    viewType: 'tail',
    orderbyTypes: [],
    showMenu: false,
    showOrganizationsSelect: false,
    showJitOrganizationsSelect: false,
    showBullPhishOrganizationsSelect: false,
    bullPhishSelectedOrganization: '',
    sortingEnabledOptions: {
        changeViewEnabled: false,
        filtersViewEnabled: false,
        orderByEnabled: false,
        organizationsEnabled: false,
        actionMenuEnabled: false,
        launchpadSortingEnabled: false
    },
    activeFilters: [],
    actionMenuOptions: [],
    orderBy: {
        property: '',
        direction: Order.asc
    }
};

export function listPageBar(state = initialUserState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case SHOW_SORT_MENU:
            return {
                ...state,
                showMenu: true,
            };
        case SHOW_ORG_SELECT:
            return {
                ...state,
                showOrganizationsSelect: true,
                sortingEnabledOptions: {
                    organizationsEnabled: true,
                }
            };
        case SHOW_JIT_ORG_SELECT:
            return {
                ...state,
                showJitOrganizationsSelect: true,
                sortingEnabledOptions: {
                    organizationsEnabled: true,
                }
            };
        case SHOW_BULL_PHISH_ORG_SELECT:
            return {
                ...state,
                showBullPhishOrganizationsSelect: true,
            };
        case CHANGE_BULL_PHISH_ORGANIZATION_SELECT:
            return {
                ...state,
                bullPhishSelectedOrganization: payload,
            };
        case HIDE_SORT_MENU:
            return {
                ...state,
                showMenu: false,
            };
        case RESET_SORT_MENU:
            return {
                ...initialUserState,
            };
        case SET_ORDERBY_TYPES:
            return {
                ...state,
                orderbyTypes: payload,
            };
        case CHANGE_VIEW_TYPE:
            return {
                ...state,
                viewType: payload,
            };
        case CHANGE_ORDERBY_TYPE:
            return {
                ...state,
                currentOrderby: payload,
            };
        case SET_ORDER_BY_PROPERTY:
            return {
                ...state,
                property: payload,
            };
        case SET_ORDER_BY_DIRECTION:
            return {
                ...state,
                direction: payload,
            };
        case SORTING_FILTERS_ENABLED:
            return {
                ...state,
                sortingFiltersEnabled: payload
            };
        case SORTING_SELECT_ENABLED:
            return {
                ...state,
                selectData: payload
            };

        case SORTING_ENABLED_OPTIONS:
            return {
                ...state,
                sortingEnabledOptions: payload
            };

        case ADD_ACTIVE_FILTER:
            if (state.activeFilters.some(filter => filter.name === payload.name)) {
                return {
                    ...state,
                    activeFilters: [...state.activeFilters.filter(filter => filter.name !== payload.name), payload]
                };
            }
            return {
                ...state,
                activeFilters: [...state.activeFilters, payload]
            };

        case SET_ACTIVE_FILTERS:
            return {
                ...state,
                activeFilters: payload
            };

        case REMOVE_ACTIVE_FILTER:
            return {
                ...state,
                activeFilters: state.activeFilters.filter(filter => filter.name !== payload)
            };

        case CLEAR_ACTIVE_FILTERS:
            return {
                ...state,
                activeFilters: []
            };

        case SET_ACTION_MENU:
            return {
                ...state,
                actionMenuOptions: payload,
            };

        default:
            return state;
    }
}
